var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6654 8.00065C14.6654 4.32065 11.6787 1.33398 7.9987 1.33398C4.3187 1.33398 1.33203 4.32065 1.33203 8.00065C1.33203 11.2273 3.62536 13.914 6.66536 14.534V10.0007H5.33203V8.00065H6.66536V6.33398C6.66536 5.04732 7.71203 4.00065 8.9987 4.00065H10.6654V6.00065H9.33203C8.96536 6.00065 8.66536 6.30065 8.66536 6.66732V8.00065H10.6654V10.0007H8.66536V14.634C12.032 14.3007 14.6654 11.4607 14.6654 8.00065Z",
    fill: "#2A6AF6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.a078439fa4b684b9c1fb9ea1e98c4f8f.svg";
export { ForwardRef as ReactComponent };